import React, { useState, useEffect } from 'react';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import { Toaster } from './components/ui/toaster';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
import Templates from './components/Templates';
import Pricing from './components/Pricing';
import Footer from './components/Footer';
import { getGuestStatus } from './lib/utils';

function App() {
  const [guestStatus, setGuestStatus] = useState(null);
  const [isCheckingGuest, setIsCheckingGuest] = useState(true);

  const refreshGuestStatus = async () => {
    try {
      const data = await getGuestStatus();
      setGuestStatus(data);
    } catch (err) {
      console.error('Failed to load guest status:', err);
    } finally {
      setIsCheckingGuest(false);
    }
  };

  useEffect(() => {
    refreshGuestStatus();
  }, []);

  if (isCheckingGuest) {
    return (
      <HelmetProvider>
        <div className="min-h-screen flex items-center justify-center bg-slate-50">
          <div className="flex flex-col items-center gap-4">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600" />
            <p className="text-slate-500 text-sm">Loading...</p>
          </div>
        </div>
      </HelmetProvider>
    );
  }

  return (
    <HelmetProvider>
      <Helmet>
        <title>Format Resume - Professional Resume Formatting Service</title>
        <meta
          name="description"
          content="Transform resumes into professional formats instantly. Perfect for recruiters and staffing agencies. Download as PDF."
        />
      </Helmet>
      <div className="min-h-screen overflow-x-hidden bg-slate-50 selection:bg-indigo-100 selection:text-indigo-900">
        <Header />
        <main className="space-y-10 pb-10">
          <Hero
            guestStatus={guestStatus}
            onGuestStatusRefresh={refreshGuestStatus}
            isGuest={true}
          />
          <Features />
          <HowItWorks />
          <Templates />
          <Pricing />
        </main>
        <Footer />
        <Toaster />
      </div>
    </HelmetProvider>
  );
}

export default App;
